import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Select, Input, Button } from 'antd';
import { toast } from 'react-toastify';
import apiRequest from '../../hooks/ApiRequest';

const { Option } = Select;

const AddEditFieldTypesForm = ({
  form,
  fieldTypeId,
  modalVisible,
  onSuccess,
}) => {
  const { getFieldDecorator, setFieldsValue, resetFields } = form;
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const insurerId = localStorage.getItem('insurerId')
    ? parseInt(localStorage.getItem('insurerId'), 10)
    : null;


  const fetchFieldtypeById = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/fieldtype/${id}`,
        'GET'
      );
      if (res.success) {
        // debugger;
        const data = res.data;
        setFieldsValue({
          name: data.name
        });
      } else {
        toast.error('Failed to fetch claim limit details');
      }
    } catch (err) {
      toast.error('Error loading claim limit');
    }
  };

  useEffect(() => {
    if (fieldTypeId) {
      fetchFieldtypeById(fieldTypeId);
    } else {
      resetFields();
    }
  }, [fieldTypeId, modalVisible]);

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;

      const payload = {
        id: fieldTypeId || 0,
        name: values.name,
        insurerId: insurerId,

      };

      try {
        const url = fieldTypeId
          ? `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/update/fieldtype`
          : `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/add/fieldtype`;

        const res = await apiRequest(url, 'POST', payload);
        if (res?.id || res?.success) {
          toast.success(fieldTypeId ? 'Field type updated' : 'Field type added');
          onSuccess && onSuccess();
        } else {
          toast.error(res?.message || 'Something went wrong');
        }
      } catch (err) {
        toast.error('Server error occurred');
      }
    });
  };


  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col md={12}>
          <Form.Item label="Name">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Please enter Name' }],
            })(
              <Input placeholder="Enter Name" type="text" />
            )}
          </Form.Item>
        </Col>


      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Form.create({ name: 'claim_limit_form' })(AddEditFieldTypesForm);
